import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../interfaces/IReduxState";
import { IOrderItemDetail } from "../../pages/orderDetailMaster/IOrderDetailMaster";
import { FAILED } from "../login-and-create-password/login-reducer";

//item master list filter
const FilterOrderDetailMaster = createSlice({
  name: "FilterOrderDetailMaster",
  initialState: {} as IReduxState<IOrderItemDetail[]>,
  reducers: {
    filterOrderDetailMasterStart: (state, _) => {
      state.isLoading = true;
    },
    successFilterOrderDetailMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;

      action.payload?.result?.length === 0 && FAILED(action.payload);
    },
    failureFilterOrderDetailMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      FAILED(action.payload);
    },
    clearFilterOrderDetailMaster: (state) => {
      state.data = {};
    },
  },
});

export const {
  filterOrderDetailMasterStart,
  successFilterOrderDetailMaster,
  failureFilterOrderDetailMaster,
  clearFilterOrderDetailMaster,
} = FilterOrderDetailMaster.actions;

export default FilterOrderDetailMaster.reducer;
